module.exports = __webpack_public_path__ + "img/signatures.e8b8fba9.webp";